import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QrCode, Coins, Gift, ChartBar, CreditCard } from "@phosphor-icons/react";
import api from "@/lib/api";
import { pts } from "@/lib/format";

const actions = [
  { key: "scan", icon: QrCode, label: "Scan Customer", intent: "" },
  { key: "award", icon: Coins, label: "Award Points", intent: "award" },
  { key: "redeem", icon: Gift, label: "Redeem Reward", intent: "redeem" },
];

export default function StaffHome() {
  const nav = useNavigate();
  const [today, setToday] = useState(null);

  useEffect(() => {
    api.get("/staff/today").then((r) => setToday(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display font-bold text-2xl">Quick actions</h1>
        <p className="text-sm text-muted-foreground">Serve customers in seconds.</p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {actions.map((a, i) => (
          <button key={a.key} data-testid={`action-${a.key}`}
            onClick={() => nav(`/staff/scan${a.intent ? `?intent=${a.intent}` : ""}`)}
            className="card-surface h-32 flex flex-col items-center justify-center gap-3 hover:-translate-y-1 transition-transform active:scale-95 fade-up" style={{ animationDelay: `${i * 50}ms` }}>
            <div className="h-12 w-12 rounded-2xl bg-primary/15 flex items-center justify-center">
              <a.icon size={26} weight="duotone" className="text-primary" />
            </div>
            <span className="font-medium text-sm">{a.label}</span>
          </button>
        ))}
        <button data-testid="action-today" onClick={() => nav("/staff/today")}
          className="card-surface h-32 flex flex-col items-center justify-center gap-3 hover:-translate-y-1 transition-transform active:scale-95 fade-up" style={{ animationDelay: "150ms" }}>
          <div className="h-12 w-12 rounded-2xl bg-primary/15 flex items-center justify-center">
            <ChartBar size={26} weight="duotone" className="text-primary" />
          </div>
          <span className="font-medium text-sm">Today's Activity</span>
        </button>
        <button data-testid="action-card" onClick={() => nav("/staff/card")}
          className="card-surface h-32 flex flex-col items-center justify-center gap-3 hover:-translate-y-1 transition-transform active:scale-95 fade-up col-span-2" style={{ animationDelay: "200ms" }}>
          <div className="h-12 w-12 rounded-2xl bg-primary/15 flex items-center justify-center">
            <CreditCard size={26} weight="duotone" className="text-primary" />
          </div>
          <span className="font-medium text-sm">Register / Activate OneKite Card</span>
        </button>
      </div>

      {today && (
        <div className="card-surface p-5">
          <p className="text-xs text-muted-foreground mb-3 uppercase tracking-wider font-mono">Today so far</p>
          <div className="grid grid-cols-3 text-center">
            <div><p className="font-display font-bold text-2xl" data-testid="today-customers">{today.customers}</p><p className="text-[10px] text-muted-foreground">Customers</p></div>
            <div><p className="font-display font-bold text-2xl text-primary" data-testid="today-points">{pts(today.points_issued)}</p><p className="text-[10px] text-muted-foreground">Points</p></div>
            <div><p className="font-display font-bold text-2xl" data-testid="today-redemptions">{today.redemptions}</p><p className="text-[10px] text-muted-foreground">Redeemed</p></div>
          </div>
        </div>
      )}
    </div>
  );
}
